import axios from 'axios';
import { IAssessmentHistoryCollection, IAssessmentHistoryParams } from 'entities/AssessmentHistory/AssessmentHistory.models';

const basePath = 'patient-metrics';

export const assessmentHistoryTransport = {
  getAssessmentHistoryCollection: (params: IAssessmentHistoryParams): Promise<IAssessmentHistoryCollection> =>
    axios.get(`${basePath}/${params.patientId}/assessment-history`, { params: { page: params.page } }),
};
